export default "__VITE_ASSET__CudViSVc__"